module.exports = __webpack_public_path__ + "img/close.c142baf3.png";